import * as React from 'react'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'

import DailyShifts from './DailyShifts'
import HourlyShifts from './HourlyShifts'

interface Props {
  store: Store
  showHourBalance: boolean
  isDaily: boolean
}

const Shifts = ({ store, showHourBalance, isDaily }: Props) => {
  const { featureAvailability: canSeeHourBalance } =
    useAttendanceFeatures('hour_balance_visibility')
  const effectiveShowHourBalance = showHourBalance && canSeeHourBalance

  if (isDaily) {
    return <DailyShifts store={store} showHourBalance={effectiveShowHourBalance} />
  }

  return <HourlyShifts store={store} showHourBalance={effectiveShowHourBalance} />
}

export default Shifts
